import { render, staticRenderFns } from "./EditModulosMateria.vue?vue&type=template&id=1f776149&scoped=true&"
import script from "./EditModulosMateria.vue?vue&type=script&lang=js&"
export * from "./EditModulosMateria.vue?vue&type=script&lang=js&"
import style0 from "./EditModulosMateria.vue?vue&type=style&index=0&id=1f776149&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f776149",
  null
  
)

export default component.exports